const getCsrf = () => {
  const name = document.querySelector("meta[name='csrf-param']").content;
  const value = document.querySelector("meta[name='csrf-token']").content;

  return { name, value };
};

export const redirectTo = (url, method = "POST") => {
  const input = document.createElement("input");
  const form = document.createElement("form");
  const csrf = getCsrf();

  input.name = csrf.name;
  input.value = csrf.value;
  form.appendChild(input);

  form.action = url;
  form.method = method;
  form.style.display = "none";

  document.body.appendChild(form);
  form.submit();
};
